<template>
  <v-row>
    <v-col
      class="font-weight-bold"
      cols="12"
      md="3"
    >
      {{ program.name }}
    </v-col>

    <LabeledNumber
      v-model="program.enrollments_count"
      @change="emit('change')"
      cols="12"
      md="3"
      message="Enrollments - current"
      dense
      round
    />

    <LabeledNumber
      v-model="program.openings_count"
      @change="emit('change')"
      cols="12"
      md="3"
      message="Openings - current"
      dense
      round
    />

    <LabeledSelect
      v-model="program.future_openings"
      @change="emit('change')"
      :items="[
        { text: 'Yes', value: true },
        { text: 'No', value: false },
      ]"
      cols="12"
      md="3"
      message="Future openings?"
      tooltip-text="Openings within the next 3 months"
      dense
      round
    />
  </v-row>

  <v-row
    class="d-flex justify-end mt-2"
    dense
  >
    <LabeledTextarea
      v-if="noteVisible"
      v-model="program.notes"
      @change="emit('change')"
      :description="noteDescription"
      cols="12"
      md="9"
      rows="2"
      dense
    />
    <v-btn
      v-else
      @click="noteVisible = !noteVisible"
      class="mt-2"
      color="primary"
      prepend-icon="add"
      variant="text"
    >
      {{ $bct('Add note') }}
    </v-btn>
  </v-row>
</template>

<script setup>
import LabeledNumber from '@/shared/components/form/LabeledNumber.vue';
import LabeledSelect from '@/shared/components/form/LabeledSelect.vue';
import LabeledTextarea from '@/shared/components/form/LabeledTextarea.vue';

const $bct = inject('translator');

const emit = defineEmits(['change']);

const noteDescription =
  'Add an optional internal note to capture things like upcoming changes, anticipated openings, or staffing transitions.';

const program = defineModel({ type: Object });
const noteVisible = ref(!!program.value.notes && program.value.notes.length > 0);
</script>
